import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { GridModalData } from '@app/core/components/grid/modals/grid-modal.service';
import { FileItem, FileService } from '@app/core/services/file.service';

@GridModalComponent('DocumentViewerGridTs')
@Component({
    selector: 'tt-document-viewer-grid-dialog',
    templateUrl: './document-viewer-grid-dialog.component.html',
    styleUrls: ['./document-viewer-grid-dialog.component.css'],
})
export class DocumentViewerGridDialogComponent {
    public heading = '';

    public fileItem?: FileItem | any;

    public isEmail: 'true' | 'false' = 'false';

    constructor(
        @Inject(MAT_DIALOG_DATA) data: GridModalData,
        public dialogRef: MatDialogRef<DocumentViewerGridDialogComponent>,
        private file: FileService,
    ) {
        dialogRef.updateSize('80vw', '90vh');

        if (!!data.row && 'docfilename' in data.row && !!data.row['docfilename']?.trim() && data.row['extension'] !== 'msg') {
            this.heading = data.row['docfilename'];
            this.loadFileItem(data.row['docfilename']);
        } else if (!!data.row) {
            this.isEmail = 'true';
            this.heading = data.row['item_name'];
            this.fileItem = data.row;
        }
    }

    private async loadFileItem(filename: string) {
        this.fileItem = await this.file.getFileDetails({ fileName: filename, maxWidth: 1200, maxHeight: 600 });
    }
}
